import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import {
  Dashboard as DashboardIcon,
  QuestionAnswer as QuestionAnswerIcon,
  PieChart as PieChartIcon,
  Lightbulb as RecommendationsIcon,
  AutoGraph as SectorIcon,
  BarChart as MarketCapIcon, // Renamed from DragHandle
  ShowChart as ShowChartIcon,
  AssignmentTurnedIn as InsightsIcon,
} from '@mui/icons-material';

// Define a simple X/Twitter icon component since Material-UI doesn't have one
export const XIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </SvgIcon>
);

// Constants
export const DRAWER_WIDTH = 240;

// Define an interface for the subpage items
interface MarketAnalysisSubpage {
  id: string;
  label: string;
  icon: React.ReactElement;
  view: string;
  description: string;
}

// Market Analysis subpages - add this back with the new subpages
export const MARKET_ANALYSIS_SUBPAGES: MarketAnalysisSubpage[] = [
  { id: 'dashboard', label: 'Market All Up', icon: <DashboardIcon fontSize="small" />, view: 'dashboard', description: 'Overview of key market insights and metrics' },
  { id: 'questions', label: 'Key Questions', icon: <QuestionAnswerIcon fontSize="small" />, view: 'questions', description: 'Answers to important investment questions' },
  // { id: 'allocation', label: 'Allocation', icon: <PieChartIcon fontSize="small" />, view: 'allocation', description: 'Recommended portfolio allocation strategy' },
  { id: 'recommendations', label: 'Recommendations', icon: <RecommendationsIcon fontSize="small" />, view: 'recommendations', description: 'Investment recommendations based on market analysis' },
  { id: 'sectors', label: 'Sector Analysis', icon: <SectorIcon fontSize="small" />, view: 'sectors', description: 'Sector-by-sector breakdown and analysis' },
  { id: 'market-caps', label: 'Marketcap Analysis', icon: <MarketCapIcon fontSize="small" />, view: 'market-caps', description: 'Analysis by market capitalization' },
  // { id: 'trends', label: 'Market Factors', icon: <ShowChartIcon fontSize="small" />, view: 'trends', description: 'Detailed analysis of market performance and risk' },
  { id: 'insights', label: 'Complete Report', icon: <InsightsIcon fontSize="small" />, view: 'insights', description: 'Comprehensive market analysis report' }
];
